import { isDefaultedSellerLocationFilter } from '../marketplace_filter_row';
import { Filter } from '../search_filters';

export function getFiltersTotal(filters : Filter[], excludedFilterKeys: string[], userShippingRegionCode: string) {

  const selectedFilterCounts = filters.map(filter => {
    const key = filter.aggregationName || filter.key;

    if (excludedFilterKeys.includes(key)) return 0;

    const selectedOptions = filter.options.filter(option => {
      if (option.all) return false;
      if (key === 'SHIPS_TO' && option.optionValue === userShippingRegionCode) return false;
      if (isDefaultedSellerLocationFilter(key, userShippingRegionCode)) return false;
      return option.selected;
    });

    return selectedOptions?.length;
  });

  return selectedFilterCounts.length > 0 && selectedFilterCounts.reduce((total, filter) => {
    return filter > 0 ? total + filter : total;
  });
}
